var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidemenuBgTopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 235,
    viewBox: "0 0 232 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1706_33294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.094 53.5147L427.978 60.6315C435.199 62.7105 438.884 70.4448 436.078 77.494C420.178 117.439 392.204 152.482 356.231 177.229C320.258 201.976 277.529 215.572 234.562 216.123C226.975 216.223 221.048 210.032 221.71 202.53L223.961 176.746C224.555 170.049 230.227 164.693 237.001 164.552C269.165 163.943 300.184 153.917 327.341 135.234C354.499 116.552 374.953 91.1688 387.022 61.348C389.56 55.0516 396.605 51.6907 403.072 53.5299L403.094 53.5147Z",
    fill: "#0D968F",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5992 -4.05499L66.646 -2.66706C73.4109 -2.29678 78.6521 3.13461 78.5752 9.8231C78.1487 41.588 87.2996 71.9147 105.344 98.1454C121.619 121.802 143.876 140.08 170.166 151.475C176.328 154.155 179.208 161.148 176.751 167.515L167.382 191.939C164.672 198.985 156.57 202.473 149.706 199.581C114.016 184.509 83.8354 159.991 61.8658 128.056C37.9634 93.3103 25.577 51.5275 26.4119 9.08585C26.5567 1.59237 33.021 -4.46615 40.5992 -4.05499Z",
    fill: "#0D968F",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.81 -79.2218C130.853 -45.5426 117.536 20.0929 150.066 67.3793C182.595 114.666 248.654 125.696 297.611 92.0172C346.568 58.338 359.885 -7.29752 327.356 -54.5839C294.826 -101.87 228.768 -112.901 179.81 -79.2218Z",
    fill: "#0D968F",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1706_33294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206.714,
    height: 300,
    fill: "white",
    transform: "translate(340.336 188.163) rotate(145.475)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidemenuBgTopIcon);
export default __webpack_public_path__ + "static/media/sidemenu-bg-top-icon.32b9e7c4e2a426ba9d8c0168028be48e.svg";
export { ForwardRef as ReactComponent };